import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import {
    CommandBarButton,
    Dropdown,
    MessageBarType,
    IDropdownOption
} from "office-ui-fabric-react";
import H from "history";
import ApiService from './ApiService';
import DispatchProps from '../utils/DispatchProps';
import Actions from '../redux/Actions';
import { ONBOARD_STATUS_DROPDOWN_OPTIONS, OnboardStatus } from '../models/School';
import { IRootState } from '../store';

interface ForceOnboardStatusProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
    history: H.History;
}

interface ForceOnboardStatusState {
    loading: boolean;
    selectedStatus: OnboardStatus;
}

class ForceOnboardStatus extends Component<ForceOnboardStatusProps & DispatchProps, ForceOnboardStatusState> {
    static displayName = ForceOnboardStatus.name;

    constructor(props: ForceOnboardStatusProps & DispatchProps) {
        super(props);

        this.state = {
            loading: false,
            selectedStatus: "notStarted"
        }
    }

    async componentDidMount() {
        await this.getCurrentStatus(false);
    }

    async componentDidUpdate(prevProps: Readonly<ForceOnboardStatusProps & DispatchProps>, prevState: ForceOnboardStatusState) {
        if (prevProps.tenantId != this.props.tenantId || prevProps.schoolCode != this.props.schoolCode) {
            await this.getCurrentStatus(false);
        }
    }

    private async getCurrentStatus(forceReload: boolean) {
        this.setState({ loading: true });
        var school = await this.props.apiService.getSchoolAdmin(this.props.tenantId, this.props.schoolCode, forceReload);
        this.setState({ loading: false, selectedStatus: school.onboardStatus ? school.onboardStatus : "notStarted" });
    }

    private onDropdownSelection = async (event: any, o?: IDropdownOption) => {
        this.setState({
            selectedStatus: o?.key as OnboardStatus
        });
    }

    private save = async () => {
        try {
            this.setState({ loading: true });
            await this.props.apiService.forceOnboardStatus(this.props.tenantId, this.props.schoolCode, this.state.selectedStatus);
            
            //clear school cache
            await this.props.apiService.getSchool(this.props.tenantId,this.props.schoolCode,true);
            await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode,true);
            
            this.props.dispatch(Actions.showMessageBar("Changed onboard status", MessageBarType.success));
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Failed to change onboard status : ${e.message}`, MessageBarType.error))
        }
        finally {
            this.setState({ loading: false });
        }
        await this.getCurrentStatus(true);
    }


    render() {
        return (
            <Fragment>
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Change Onboard Status</span>
                        <CommandBarButton
                            iconProps={{ iconName: "save" }}
                            text="Save"
                            onClick={this.save}
                            disabled={this.state.loading} />
                    </div>
                    <div className="card__content flex-column">
                        <Dropdown
                            label=""
                            selectedKey={this.state.selectedStatus}
                            onChange={this.onDropdownSelection}
                            placeholder="Select status"
                            options={ONBOARD_STATUS_DROPDOWN_OPTIONS}
                            styles={{ dropdown: { width: 300 } }}
                            disabled={this.state.loading} />
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): ForceOnboardStatusProps => {
        return {
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history,
        };
    }
)(ForceOnboardStatus)